import { Injectable, Inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { map, mergeMap, catchError } from 'rxjs/operators';
import * as UserActions from './actions';
import { IUsersService } from '../../services/users/definitions';
import { UsersServiceToken } from '../../services/users/main';

@Injectable({
  providedIn: 'root',
})
export class Effects {
  public constructor(
    private actions$: Actions,
    @Inject(UsersServiceToken)
    private usersService: IUsersService,
  ) {}

  public fetchUsers$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(UserActions.ActionTypes.FetchUsers),
      mergeMap(({ payload }) =>
        this.usersService.getUsers(payload).pipe(
          map((users) => new UserActions.FetchUsersSuccess(users)),
          catchError((error) => of(new UserActions.FetchUsersFailure(error))),
        ),
      ),
    );
  });

  public createUser$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(UserActions.ActionTypes.CreateUser),
      mergeMap(({ payload }) =>
        this.usersService.createUser(payload).pipe(
          map((user) => new UserActions.CreateUserSuccess(user)),
          catchError((error) => of(new UserActions.CreateUserFailure(error))),
        ),
      ),
    );
  });

  public updateUser$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(UserActions.ActionTypes.UpdateUser),
      mergeMap(({ payload }) =>
        this.usersService.updateUser(payload).pipe(
          map((user) => new UserActions.UpdateUserSuccess()),
          catchError((error) => of(new UserActions.UpdateUserFailure(error))),
        ),
      ),
    );
  });

  public updateUserPassword$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(UserActions.ActionTypes.UpdateUserPassword),
      mergeMap(({ payload }) =>
        this.usersService.updateUserPassword(payload).pipe(
          map(() => new UserActions.UpdateUserSuccess()),
          catchError((error) => of(new UserActions.UpdateUserFailure(error))),
        ),
      ),
    );
  });

  public enableUser$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(UserActions.ActionTypes.EnableUser),
      mergeMap(({ payload }) =>
        this.usersService.enableUser(payload).pipe(
          map(() => new UserActions.UserStatusUpdateSuccess()),
          catchError((error) =>
            of(new UserActions.UserStatusUpdateFailure(error)),
          ),
        ),
      ),
    );
  });

  public disableUser$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(UserActions.ActionTypes.DisableUser),
      mergeMap(({ payload }) =>
        this.usersService.disableUser(payload).pipe(
          map(() => new UserActions.UserStatusUpdateSuccess()),
          catchError((error) =>
            of(new UserActions.UserStatusUpdateFailure(error)),
          ),
        ),
      ),
    );
  });
}
